// Auth Token

export const setAccessToken = (token) => {
  if (!token) return false

  return localStorage.setItem('accessToken', token)
}

export const setUserId = (userId) => {
  if (!userId) return false

  return localStorage.setItem('userId', userId)
}

export const getUserId = () => localStorage.getItem('userId')

export const removeUserId = () => localStorage.removeItem('userId')

export const getAccessToken = () => localStorage.getItem('accessToken')

export const removeAccessToken = () => localStorage.removeItem('accessToken')

// Email cache

export const removeEmailCache = () => {
  localStorage.removeItem('emailCache')
}

export const receiveEmailCache = (email) => {
  localStorage.setItem('emailCache', email)
}

export const getEmailCache = () => localStorage.getItem('emailCache') || ''

export const emailCache = (credentials) => {
  const { email, remember } = credentials

  if (!remember) return removeEmailCache()

  return receiveEmailCache(email)
}
